export default class Navigation {
  constructor() {
    this.navSetup = false;
    this.navigationLarge = false;
    this.withLimit = 923;
    if (document.getElementsByTagName("HTML")[0].lang === "fr") {
      this.withLimit = 1110;
    }

    this.updateUI();
    this.handleScroll();
    $(window).resize(() => this.handleResize());
    $(window).scroll(() => this.handleScroll());
  }

  updateUI() {
    // console.log("this.withLimit " + this.withLimit)
    // Navigation Layout & Events Setup
    if ($(window).width() > this.withLimit) {
      this.positionSubMenus();

      if (!this.navigationLarge) {
        this.closeSmallNavigation();
      }

      if (!this.navSetup) {
        this.setupLargeNavigation();
      }
    } else {
      if (this.navigationLarge) {
        this.closeLargeNavigation();
      }

      if (!this.navSetup) {
        this.setupSmallNavigation();
      }
    }

    if (
      this.showDropInNav &&
      !$("nav.siteNav__main").hasClass("is-active") &&
      $(window).width() > this.withLimit
    ) {
      $("nav.siteNav__main").one("transitionend", () => {
        $("nav.siteNav__main").removeClass("do-reveal");
      });
      $("nav.siteNav__main").addClass("is-active");
      $("nav.siteNav__main").addClass("do-reveal");
    } else if (
      !this.showDropInNav &&
      $("nav.siteNav__main").hasClass("is-active") &&
      $(window).width() > this.withLimit
    ) {
      $("nav.siteNav__main").removeClass("is-active");
      $("nav.siteNav__main").removeClass("do-reveal");
      this.closeAllMenus();
    }
  }

  setupLargeNavigation() {
    this.navigationLarge = true;
    console.log("setup large");
    /*  Navigation Elements */

    // submenu triggers
    $("nav.siteNav__main>div>.submenuBtn").click((e) => {
      const menuname = `submenu__${$(e.currentTarget).data("submenu")}`;

      // close the menu!
      if ($(`nav.siteNav__main div.${menuname}`).hasClass("is-active")) {
        $("nav.siteNav__main").removeClass("has--submenu");
        $(`nav.siteNav__main div.${menuname}`).removeClass("is-active");
        $("nav.siteNav__main a").removeClass("is-highlighted");
      } else {
        // open the menu!
        $("nav.siteNav__main div.submenu").removeClass("is-active");
        $("nav.siteNav__main").addClass("has--submenu");
        $("nav.siteNav__main a").removeClass("is-highlighted");

        if (!$(`nav.siteNav__main div.${menuname}`).hasClass("is-active")) {
          $(`nav.siteNav__main div.${menuname}`).addClass("is-active");
          $(`nav.siteNav__main a.${menuname}`).addClass("is-highlighted");
        }
      }
    });

    // submenu link close all submenus
    $("nav.siteNav__main div.submenu a").click((e) => {
      this.closeAllMenus();
    });

    this.positionSubMenus();

    this.navSetup = true;

    // disable tranistions temporarily and then reenable. this will ensure elements are flying around during a tablet rotation
    $("nav.siteNav__main").css("transition", "none");
    // this line is a safari hack for fixing the render
    $("nav .submenu").css("display", "none");

    setTimeout(() => {
      $("nav.siteNav__main").css("transition", "");
      // remove the safari hack
      $("nav .submenu").css("display", "");
    }, 500);

    // when the orientation changes make sure you enable the special nav
    if ($("nav.siteNav__special").length) {
      $("nav.siteNav__special").addClass("is-active");
    }
  }

  closeAllMenus() {
    $("nav.siteNav__main").removeClass("has--submenu");
    $("nav.siteNav__main div").removeClass("is-active");
    $("nav.siteNav__main a").removeClass("is-highlighted");
  }

  closeLargeNavigation() {
    this.navigationLarge = false;
    this.navSetup = false;

    // $('nav.siteNav__main>div>a.submenuBtn,nav.siteNav__main div.submenu').off('mouseover');
    // $('nav.siteNav__main>div>a.submenuBtn,nav.siteNav__main div.submenu').off('mouseout');
    $("nav.siteNav__main>div>.submenuBtn").off("click");

    console.log("close large");
  }

  setupSmallNavigation() {
    console.log("setup small");
    // mobile nav menu
    $(".eggBurger").click(() => {
      if ($("div.eggShape").hasClass("is-active")) {
        this.closeAllMenus();
        $("div.overlayCover").removeClass("is-active");
        $("a.eggBurger>div").removeClass("is-active");
        $("div.eggShape").removeClass("is-active");
        $("nav.siteNav__main").removeClass("is-active");
      } else {
        $("div.overlayCover").addClass("is-active");
        $("a.eggBurger>div").addClass("is-active");
        $("div.eggShape").addClass("is-active");
        $("nav.siteNav__main").addClass("is-active do-reveal");

        $("nav.siteNav__main").one("transitionend", () => {
          $("nav.siteNav__main").removeClass("do-reveal");
        });
      }
    });

    // disable transitons while we rotate
    $("nav.siteNav__main").css("transition", "none");

    // make sure the nav is not visible
    if ($("nav.siteNav__main").hasClass("is-active")) {
      $("nav.siteNav__main").removeClass("is-active");
    }

    // reenable transitions after a small delay
    setTimeout(() => {
      $("nav.siteNav__main").css("transition", "");
    }, 500);

    $("nav.siteNav__main div.submenu").css("margin-left", "");

    // submenu triggers
    $("nav.siteNav__main>div>.submenuBtn").click((e) => {
      const menuname = `submenu__${$(e.currentTarget).data("submenu")}`;

      // close the menu!
      if ($(`nav.siteNav__main div.${menuname}`).hasClass("is-active")) {
        $(`nav.siteNav__main div.${menuname}`).removeClass("is-active");
        $(`nav.siteNav__main a.${menuname}`).removeClass("is-highlighted");
      } else {
        // open the menu!
        $("nav.siteNav__main div.submenu").removeClass("is-active");
        $("nav.siteNav__main a").removeClass("is-highlighted");

        if (!$(`nav.siteNav__main div.${menuname}`).hasClass("is-active")) {
          $(`nav.siteNav__main div.${menuname}`).addClass("is-active");
          $(`nav.siteNav__main a.${menuname}`).addClass("is-highlighted");
        }
      }
    });

    this.navSetup = true;
  }

  closeSmallNavigation() {
    this.navSetup = false;
    console.log("closing small");
    // disable the button events.
    $("a.eggBurger").off("click");
    $("nav.siteNav__main>div>.submenuBtn").off("click");
  }

  positionSubMenus() {
    const tpp = $("nav.siteNav__main>div>.submenu__products").position().left;
    $("nav.siteNav__main div.submenu__products").css("margin-left", `${tpp}px`);
    const npp = $("nav.siteNav__main>div>.submenu__nutrition").position().left;
    $("nav.siteNav__main div.submenu__nutrition").css(
      "margin-left",
      `${npp}px`
    );
    console.log("pos");
    console.log($("nav.siteNav__main>div>.submenu__about").position().left);
    const app =
      $("nav.siteNav__main>div>.submenu__about").position().left +
      $("nav.siteNav__main>div>.submenu__about").outerWidth() +
      20 -
      $("nav.siteNav__main div.submenu__about").outerWidth();
    $("nav.siteNav__main div.submenu__about").css("margin-left", `${tpp}px`);
    const cpp =
      $("nav.siteNav__main div.submenu__csr").outerWidth() +
      $("nav.siteNav__main>div>.submenu__csr").position().left +
      100;
    $("nav.siteNav__main div.submenu__csr").css("margin-left", `${tpp}px`);
    if (document.getElementsByTagName("HTML")[0].lang === "en") {
      const bpp =
        $("nav.siteNav__main div.submenu__blog").outerWidth() +
        $("nav.siteNav__main>div>.submenu__blog").position().left +
        100;
      $("nav.siteNav__main div.submenu__blog").css("margin-left", `${bpp}px`);
    }
  }

  handleResize() {
    this.updateUI();
  }

  handleScroll() {
    // code for the main nav to drop in on the home page after the special nav goes off screen.
    /* if ( $('body').hasClass('home') ) {

      if ( $(window).width() > 923 && $(window).scrollTop() > $('section.home__hero').height() && !this.showDropInNav ) {
        this.showDropInNav = true;
        this.updateUI();
      } else if ( $(window).width() > 923 && $(window).scrollTop() <= $('section.home__hero').height() && this.showDropInNav ) {
        this.showDropInNav = false;
        this.updateUI();
      }

    } else { */
    this.showDropInNav = true;
    this.updateUI();
    // }
  }
}



// WEBPACK FOOTER //
// ./js/controllers/modules/Navigation.js